// Panelden gelen gorunum ayarlarini CSS token'larina cevirir.
// Renkler setThemeColors'ta; burasi renk disi gorunum (yogunluk, kose, yazi boyutu).
// Ayar gelmezse hicbir sey yazilmaz ve tokens.scss'teki varsayilanlar gecerli kalir.

const DENSITY = {
    compact: { density: "0.85", bubbleGap: "10px" },
    normal: { density: "1", bubbleGap: "14px" },
    comfortable: { density: "1.2", bubbleGap: "18px" },
};

const CORNERS = {
    // scale: widget'in tamamindaki kutu/buton/giris kose olcegi (xs..pill)
    sharp: {
        widget: "6px", bubble: "6px", corner: "2px", input: "6px",
        scale: { xs: "0px", sm: "2px", md: "3px", lg: "4px", pill: "6px" },
    },
    soft: {
        widget: "23px", bubble: "20px", corner: "6px", input: "17px",
        scale: { xs: "4px", sm: "8px", md: "12px", lg: "20px", pill: "999px" },
    },
    round: {
        widget: "28px", bubble: "26px", corner: "26px", input: "26px",
        scale: { xs: "8px", sm: "14px", md: "20px", lg: "28px", pill: "999px" },
    },
};

// Hazir tasarimin yapisal imzasi: baslik, avatar ve launcher. Renk ve kose
// tek basina temalari birbirine benzetiyordu; asil farki bunlar yaratiyor.
const SYSTEMS = {
    soft: {
        "--sps-header-height": "129px",
        "--sps-header-height-mobile": "150px",
        "--sps-header-radius": "24px",
        // Simetrik dolgu: eski deger (20/6/44/18) icerigi yukari itiyor ve
        // sag kenari sikistiriyordu.
        "--sps-header-padding": "13px 14px",
        "--sps-avatar-size": "48px",
        "--sps-avatar-radius": "50%",
        "--sps-launcher-size": "64px",
        "--sps-launcher-radius": "50%",
        "--sps-spinner-size": "34px",
        "--sps-spinner-width": "3px",
        "--sps-spinner-radius": "50%",
    },
};

export const setAppearanceTokens = (appearance) => {
    if (!appearance) return;
    const root = document.querySelector(":root");
    if (!root) return;

    const density = DENSITY[appearance.density];
    if (density) {
        root.style.setProperty("--sps-density", density.density);
        root.style.setProperty("--sps-bubble-gap", density.bubbleGap);
    }

    const corners = CORNERS[appearance.corners];
    if (corners) {
        root.style.setProperty("--sps-widget-radius", corners.widget);
        root.style.setProperty("--sps-bubble-radius", corners.bubble);
        root.style.setProperty("--sps-bubble-corner", corners.corner);
        root.style.setProperty("--sps-input-radius", corners.input);
        Object.keys(corners.scale).forEach((basamak) => {
            root.style.setProperty("--sps-radius-" + basamak, corners.scale[basamak]);
        });
    }

    const fontSize = parseInt(appearance.fontSize, 10);
    if (fontSize >= 12 && fontSize <= 18) {
        root.style.setProperty("--sps-font-size", fontSize + "px");
    }

    // Yerlesim katmani CSS'ten bu isarete gore secilir: token'lar olcuyu,
    // bu oznitelik kompozisyonu (baslik dili, baloncuk bicimi, giris alani) surer.
    // Yalnizca tanimli tasarim isaret birakir; kaldirilmis eski kimlikler yok sayilir.
    if (SYSTEMS[appearance.designSystem]) {
        root.setAttribute("data-design-system", appearance.designSystem);
        if (document.body) document.body.setAttribute("data-design-system", appearance.designSystem);
    } else {
        root.removeAttribute("data-design-system");
        if (document.body) document.body.removeAttribute("data-design-system");
    }

    const system = SYSTEMS[appearance.designSystem];
    if (system) {
        Object.keys(system).forEach((token) => root.style.setProperty(token, system[token]));
    }

    // Olcegi sitede yukleyici (static/scripts.js) uygular; panel onizlemesinde yukleyici yok, widget kendini olcekler
    if (typeof window !== "undefined" && window.location.search.indexOf("preview") !== -1) {
        const scale = (Number(appearance.scale) || 100) / 100;
        root.style.zoom = scale === 1 ? "" : String(scale);
    }

    if (appearance.bubbleShadow !== undefined) {
        root.style.setProperty(
            "--sps-bubble-shadow",
            appearance.bubbleShadow ? "0 1px 2px rgba(16, 24, 40, 0.08)" : "none"
        );
    }
};

export default setAppearanceTokens;



// WEBPACK FOOTER //
// ./src/utils/setAppearanceTokens.js